import {
    CommonModule,
    ViewportScroller,
    isPlatformBrowser,
    isPlatformServer,
    registerLocaleData
} from '@angular/common';
import localeArBh from '@angular/common/locales/ar-BH';
import localeEnUS from '@angular/common/locales/en';
import {
    ApplicationRef,
    Component,
    Inject,
    Injector,
    NgZone,
    OnInit,
    PLATFORM_ID
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterOutlet
} from '@angular/router';
import * as icons from '@components/menu-icon.model';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from '@services/cart.service';
import { WishlistService } from '@services/wishlist.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import * as _ from 'lodash';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { ToastrService } from 'ngx-toastr';
import { first, take, tap } from 'rxjs/operators';
import { AuthenticationService } from './_services/authentication.service';
import { MetaTagsService } from './_services/meta-tags.service';
import { SiteService } from './_services/site.service';
import { SharedService } from './_services/shared.service';
import { CurrencyRateService } from './_services/currency-rate.service';
/* import { TawkService } from './widgets/widget-tawk/tawk.service'; */
import { SwUpdate } from '@angular/service-worker';
import { environment } from '@environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ChatService } from './_services/chat.service';
import { EventsService } from './_services/events.service';
import { UpdateSwService } from './_services/update-sw.service';
import { SideSheetComponent } from './_components/side-sheet/side-sheet.component';
import { ChatWindowComponent } from './_components/live-chat/chat-window/chat-window.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

export function getCulture() {
    return 'ar-BH';
}
@UntilDestroy()
@Component({
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        SideSheetComponent,
        ChatWindowComponent
    ],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [UpdateSwService]
    //providers: [{ provide: LOCALE_ID, useFactory: getCulture}]
})
export class AppComponent implements OnInit {
    currentUser;
    companyData;
    productData;
    gtmService: GoogleTagManagerService;

    chatWs = this.chatService.messages$.subscribe(data => {
        this.chatService.wsChat$.next(data);
    });

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private domSanitizer: DomSanitizer,
        private router: Router,
        private matIconRegistry: MatIconRegistry,
        private toastr: ToastrService,
        private cart: CartService,
        private wishlist: WishlistService,
        private zone: NgZone,
        private scroller: ViewportScroller,
        private auth: AuthenticationService,
        // @Optional() private TawkService: TawkService,
        private $gaService: GoogleAnalyticsService,
        private eventsService: EventsService,
        // private gtmService: GoogleTagManagerService,
        public translate: TranslateService,
        private metaTagsService: MetaTagsService,
        private route: ActivatedRoute,
        private injector: Injector,
        private sw: UpdateSwService,
        // private gtmService: GoogleTagManagerService,
        private chatService: ChatService,
        public deviceDetector: DeviceDetectorService,
        public siteService: SiteService,
        private sharedService: SharedService,
        private currencyRateService: CurrencyRateService,
        //private swUpdate: SwUpdate,
        appRef: ApplicationRef
    ) {
        if (isPlatformBrowser(this.platformId)) {
            appRef.isStable
                .pipe(first(stable => stable === true))
                .subscribe(stable => {
                    console.log('App is stable');
                    this.sw.init();
                });
        }
        /* this.checkForNewVersion(); */
        /* setInterval(() => this.checkForNewVersion(), 60 * 1000);

        if (isPlatformBrowser(this.platformId) && this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates.pipe(
                filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
                map(async evt => {
                    await this.swUpdate.activateUpdate();
                    window.location.reload();
                    return {
                        type: 'UPDATE_AVAILABLE',
                        current: evt.currentVersion,
                        available: evt.latestVersion,
                    }
                }))

            this.swUpdate.checkForUpdate().then(() => {
            }).catch((error) => {
                console.error('Could not check for app updates', error);
            });
        } */

        if (environment.production && environment.integrations?.gtag?.id) {
            this.gtmService = this.injector.get<any>(GoogleTagManagerService);
            this.gtmService.addGtmToDom();
        }

        if (
            isPlatformBrowser(this.platformId) &&
            (window as any)?.mobileInit &&
            typeof (window as any)?.mobileInit.postMessage == 'function'
        )
            (window as any)?.mobileInit.postMessage('init');

        _.forEach(icons, icon => {
            this.matIconRegistry.addSvgIconLiteral(
                icon.name,
                this.domSanitizer.bypassSecurityTrustHtml(icon.data)
            );
        });

        const domain =
            (isPlatformServer(this.platformId) && environment.web + '/') || '';
        this.matIconRegistry.addSvgIcon(
            'add_to_cart_custom',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/add_cart.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'cart_circle',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/cart_circle.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'twitter',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/twitter.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'twitter-white',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/twitter_white.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'instagram',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/instagram.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'instagram-white',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/instagram_white.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'cart-n',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/cart-n.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'quote-n',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote-n.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'quotations_new',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quotations_new.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'burger-n',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/burger-n.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'profile-n',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/profile-n.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'whatsapp',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/whatsapp.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'check_circle',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/check_circle.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'select_unchecked',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/select_unchecked.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'select_checked',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/select_checked.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'select_unchecked_circle',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/select_unchecked_circle.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'chat_elipses',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/chat_elipses.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'right-arrow',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/right-arrow.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'left-arrow',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/left-arrow.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'right-arrow2',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/arrow_forward.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'left-arrow2',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/arrow_back.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'right-chevron',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/product-slider/arrow_right.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'left-chevron',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/product-slider/arrow_left.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'down-chevron',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/arrowhead_down.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'chat-info',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/chat_info.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'chat-elipses',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/chat_elipses.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'chat_with_us',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/chat_with_us.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'consult_us',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/consult_us.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'call',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/call.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'instagram',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/instagram.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'linkedin',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/linkedin.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'facebook',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/facebook.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'star-square',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/star_square.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'report',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/report.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'astrisk',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/astrisk.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'arrow-up-eject',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/arrow_up_eject.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'quotation-tag',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quotation.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'active-quotation',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/active_quotation.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'addresses',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/addresses.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'dashboard',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/dashboard.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'vouchers',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/vouchers.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'edit',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/edit.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'edit-profile',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/edit_profile.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'booking',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/booking.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'live-chat',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/live_chat.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'logout',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/logout.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'messages',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/messages.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'order-history',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/order_history.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'password',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/password.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'pdf-download',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/pdf_download.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'app-store',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/app-store.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'google-play',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/google-play.svg'
            )
        );

        this.auth.currentUser.subscribe((user: any) => {
            this.currentUser = user;
            if (
                this.siteService?.siteSetting?.companyId ||
                !this.siteService.features?.chat
            )
                return;
            if (
                (!user || _.isEmpty(user)) &&
                this.siteService?.siteSetting.loggedInOnly
            )
                this.router.navigate(['/login']);
            if (user) {
                this.chatService.connect({ reconnect: true });
            }
        });

        this.matIconRegistry.addSvgIcon(
            'call-footer',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/call_footer.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'clock-footer',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/clock_footer.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'email-footer',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/email_footer.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'email',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/email.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'location-footer',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/location_footer.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'arrow-down',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/arrow_down.svg'
            )
        );

        this.matIconRegistry.addSvgIcon(
            'document-view',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/document-view.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'document',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/document.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'pen',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/pen.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'letter',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/letter.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'money',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/money.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'stack',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/stack.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'time',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/time.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'view-table',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/view-table.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'upload',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/upload.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'file',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/file.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'project',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/project.svg'
            )
        );
        this.matIconRegistry.addSvgIcon(
            'location',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                domain + 'assets/svg/quote/location.svg'
            )
        );

        /* if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                this.router.events.pipe(filter(event => event instanceof NavigationEnd), first()).subscribe(() => {
                    const preloader = document.querySelector('.site-preloader');

                    preloader.addEventListener('transitionend', (event: TransitionEvent) => {
                        if (event.propertyName === 'opacity') {
                            preloader.remove();
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                });
            });
        } */
    }

    ngOnDestroy() {
        /*         if (isPlatformBrowser(this.platformId)) {
                    this.TawkService?.SetChatVisibility(false);
                } */
    }

    leet(url) {
        if (!url) return;
        (window as any).zone.run(() => (window as any).router.navigate([url]));
    }
    ngOnInit(): void {
        if (
            isPlatformBrowser(this.platformId) &&
            this.deviceDetector.isMobile() &&
            !environment.production
        ) {
            (window as any).router = this.router;
            (window as any).leet = this.leet;
            (window as any).zone = this.zone;
        }

        // Initialize country selection on app start
        // CRITICAL: We get both the countries list AND the backend's selectedCountryId
        // This ensures the backend session country (source of truth) takes priority
        if (isPlatformBrowser(this.platformId)) {
            // First, get user details which includes selectedCountryId from backend session
            this.auth.getUserDetails().pipe(take(1)).subscribe(
                (userDetailsResponse: any) => {
                    const backendCountryId = userDetailsResponse?.selectedCountryId;
                    
                    // Then get the countries list with currencies
                    this.auth.getCountryCodes().subscribe(countriesResponse => {
                        if (countriesResponse?.data) {
                            // Pass backend country ID to ensure session country is prioritized
                            this.sharedService.initializeCountrySelection(
                                countriesResponse.data,
                                backendCountryId
                            );
                        }
                    });
                },
                (error) => {
                    console.error('[App] Failed to get user details:', error);
                    // Fallback: Initialize countries without backend ID
                    this.auth.getCountryCodes().subscribe(response => {
                        if (response?.data) {
                            this.sharedService.initializeCountrySelection(
                                response.data
                            );
                        }
                    });
                }
            );
        }

        // Currency rates are now loaded by AuthenticationService.loadUserDetails()
        // This ensures rates load AFTER user currency is determined (logged-in users)
        // No need to load rates here as it would race with user details loading
        // See: authentication.service.ts -> loadUserDetails() method

        /* REMOVED: Redundant rate loading moved to authentication service
        if (isPlatformBrowser(this.platformId)) {
            this.currencyRateService.loadRates().subscribe({...});
            
            this.auth.currentUser.pipe(untilDestroyed(this)).subscribe(user => {
                if (user) {
                    this.currencyRateService.loadRates(true).subscribe({...});
                }
            });
        }
        */

        registerLocaleData(localeArBh, 'ar');
        registerLocaleData(localeEnUS, 'en');
        /*  if (isPlatformBrowser(this.platformId)) {
             this.TawkService?.SetChatVisibility(true);
         } */
        // properties of the CurrencyFormatOptions interface fully complies
        // with the arguments of the built-in pipe "currency"
        // https://angular.io/api/common/CurrencyPipe
        // this.currency.options = {
        //     code: 'BHD',
        //     // display: 'symbol',
        //     // digitsInfo: '1.2-2',
        //     // locale: 'en-US'
        // };

        //this.titleService.setTitle(environment.site?.name);
        const shouldReuseRoute = this.router.routeReuseStrategy
            .shouldReuseRoute;
        this.router.events.pipe(untilDestroyed(this)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (isPlatformBrowser(this.platformId)) {
                    setTimeout(() => {
                        this.router.routeReuseStrategy.shouldReuseRoute = shouldReuseRoute;
                        this.router.onSameUrlNavigation = 'ignore';
                    }, 0);
                }
                /*                this.metaTagsService.setMetaTags({
                                  title: "Qet",
                              }); */

                this.scroller.scrollToPosition([0, 0]);
                if (isPlatformBrowser(this.platformId)) {
                    /*                     const gtmTag = {
                                            event: 'pageview',
                                            pageName: event.url
                                        };

                                        this.gtmService.pushTag(gtmTag); */
                }

                var rt = this.getChild(this.route.firstChild);
                rt.data.subscribe(data => {
                    this.companyData = null;
                    this.productData = null;

                    if (data.categoryProducts) {
                        this.metaTagsService.setMetaTags({
                            title:
                                data.categoryProducts.category?.seo?.title?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.categoryProducts.category?.name[
                                    this.translate.currentLang || 'en'
                                ],
                            description:
                                data.categoryProducts.category?.seo
                                    ?.description?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.categoryProducts.category?.description?.[
                                    this.translate.currentLang || 'en'
                                ]
                        });
                    } else if (data.products) {
                        let firstImage = null;

                        if (data.products?.product?.images) {
                            firstImage =
                                data.products.product?.images[
                                    Object.keys(data.products.product.images)[0]
                                ];
                        }

                        this.companyData =
                            data.company?.company ||
                            data.products?.product?.companyData;
                        this.productData = data.products?.product ?? null;

                        this.metaTagsService.setMetaTags({
                            title:
                                data.products?.product?.seo?.title?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.products?.product?.name[
                                    this.translate.currentLang || 'en'
                                ],
                            description:
                                data.products?.product?.seo?.description?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.products?.product?.description?.[
                                    this.translate.currentLang || 'en'
                                ],

                            ogType: 'og:product',
                            ogUrl: this.router.url,
                            ogTitle:
                                data.products?.product?.seo?.title?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.products?.product?.name[
                                    this.translate.currentLang || 'en'
                                ],
                            ogDescription:
                                data.products?.product?.seo?.description?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.products?.product?.description?.[
                                    this.translate.currentLang || 'en'
                                ],
                            ogImage: firstImage?.icon?.url
                        });

                        if (isPlatformBrowser(this.platformId)) {
                            if (data.products.product?._id) {
                                this.eventsService.debouncer.next({
                                    name: 'view_item',
                                    category: 'catalog',
                                    type: 'navigation',
                                    itemType:
                                        data.products.product?.layout &&
                                        data.products.product?.layout !=
                                            'product'
                                            ? data.products.product?.layout
                                            : data.products.product?.type ||
                                              'product',
                                    companyId:
                                        data.products?.product?.companyData
                                            ?._id,
                                    productId: data.products.product?._id
                                });
                            }

                            this.$gaService.gtag('event', 'view_item', {
                                items: [
                                    {
                                        id: data.products.product?.code,
                                        name:
                                            data.products.product?.name[
                                                this.translate.currentLang ||
                                                    'en'
                                            ],
                                        brand:
                                            data.products.product?.brandData
                                                ?.name,
                                        category:
                                            data.products.product?.companyData
                                                ?.name[
                                                this.translate.currentLang ||
                                                    'en'
                                            ],
                                        quantity:
                                            data.products.product?.quantity
                                                ?.amount,
                                        price:
                                            data.products.product?.taxedPrice ||
                                            data.products.product?.price
                                    }
                                ]
                            });
                        }
                    } else if (data.blog) {
                        this.metaTagsService.setMetaTags({
                            title:
                                this.translate.currentLang == 'en'
                                    ? 'Blog'
                                    : 'مدونة'
                        });
                    } else if (data.post) {
                        this.metaTagsService.setMetaTags({
                            title:
                                data.post?.data?.seo?.title?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.post.data?.title[
                                    this.translate.currentLang || 'en'
                                ],
                            description:
                                data.post?.data?.seo?.description?.[
                                    this.translate.currentLang || 'en'
                                ] ||
                                data.post.data?.shortArticle?.[
                                    this.translate.currentLang || 'en'
                                ]
                        });
                    } else {
                        this.metaTagsService.setMetaTags({
                            title: this.siteService.siteSetting?.name
                        });
                    }
                });
            }
        });

        this.cart.onAdding$.subscribe(product => {
            this.toastr.success(`Product "${product.name?.en}" added to cart!`);
        });
        /* this.compare.onAdding$.subscribe(product => {
            this.toastr.success(`Product "${product.name?.en}" added to compare!`);
        }); */
        this.wishlist.onAdding$.subscribe(product => {
            this.toastr.success(
                `Product "${product.name?.en}" added to wish list!`
            );
        });
    }

    logout() {
        this.auth.logout();
        this.router.navigate(['/']);
    }

    getChild(activatedRoute: ActivatedRoute) {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        } else {
            return activatedRoute;
        }
    }

    currentIndex = 0;
    speed = 5000;
    infinite = true;
    direction = 'right';
    directionToggle = true;
    autoplay = true;
    avatars = '1234567891234'.split('').map((x, i) => {
        const num = i;
        // const num = Math.floor(Math.random() * 1000);
        return {
            url: `https://picsum.photos/600/400/?${num}`,
            title: `${num}`
        };
    });

    /*  checkForNewVersion = async () => {
         try {
             // Check if Service Worker is supported by the Browser
             if (this.swUpdate.isEnabled) {
                 // Check if new version is available
                 const isNewVersion = await this.swUpdate.checkForUpdate();
                 if (isNewVersion) {
                     // Check if new version is activated
                     const isNewVersionActivated = await this.swUpdate.activateUpdate();
 
                     // Reload the application with new version if new version is activated
                     if (isNewVersionActivated) {
                         window.location.reload();
                     }
                 }
             }
         } catch (error) {
             console.log(
                 `Service Worker - Error when checking for new version of the application: `,
                 error
             );
             window.location.reload();
         }
     }; */
}
